var exports = {
  "k": "xe533113f--e0ff94--container",
};

module.exports = exports;
